import {RootState} from "../store";

export const selectLoading = (state: RootState, action: string): boolean => state.ui.loading.includes(action);

export const selectSuccess = (state: RootState, action: string): boolean => state.ui.success.includes(action);

export const selectError = (state: RootState, action: string): boolean => state.ui.error.includes(action);
